
export const repackData = {
    total_pallets: "1",
    total_boxes: "0",
    total_kilos: "0",
    type_of_defects: "",
    remarks: "",
}